import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducers from './reducers';

import './index.scss';
import Selector from './selector';

export class PinnedListings extends Component {
  constructor(props) {
    super(props);
    const { pinnedListings, searchPath, updatePath } = props;
    const searchResults = [];
    const module = { clearing: false, updatingListingId: null, searchPath, updatePath, searchText: '', waiting: false };
    this.store = createStore(reducers, { pinnedListings, searchResults, module }, applyMiddleware(thunk));
    if (module.hot) {
      module.hot.accept('./reducers/index', () => {
        this.store.replaceReducer(require('./reducers/index'));
      });
    }
  }

  render() {
    return (
      <Provider store={this.store}>
        <div className="pinned-listings">
          <div className="my-2">
            <p className="fs-large my-0">
              Pin Listings
            </p>
            <div className="text-muted">
              Pin individual listings to always show up first on your plugin
            </div>
          </div>
          <Selector/>
        </div>
      </Provider>
    );
  }
}

PinnedListings.propTypes = {
  pinnedListings: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired
  })).isRequired,
  searchPath: PropTypes.string.isRequired,
  updatePath: PropTypes.string.isRequired
};

export default PinnedListings;
